import React from "react";
import { Nav } from "react-bootstrap";
import { useSelector } from "react-redux";
import { LinkContainer } from "react-router-bootstrap";
import {
  FaUsers,
  FaUsersSlash,
  FaMoneyBillAlt,
  FaUserPlus,
  FaClipboardList,
  FaBell,
} from "react-icons/fa"; // Add the icons you need

import { CgMenuBoxed } from "react-icons/cg";
import { MdAccountBalance } from "react-icons/md";

import preferredLanguage from "../assets/preferredLanguage.json";
import useReminders from "../utils/useReminders";

function TopSubMenu() {
  const { userInfo } = useSelector((state) => state.auth);
  // Shared with the reminders page so the badge and the page can never
  // disagree about what is outstanding.
  const { totalCount: reminderCount } = useReminders();
  const selectedLanguage = userInfo?.preferredLanguage
    ? userInfo?.preferredLanguage
    : "English";

  const subMenuStyle = {
    padding: "0.1rem 0.1rem",
    whiteSpace: "nowrap",
    width: "fit-content",
    textShadow: "3px 3px 3px rgba(20, 18, 0, 0.23)",
    color:
      new Date(userInfo?.gymId?.subsExpiryDate) < new Date()
        ? "blue"
        : userInfo?.gymId?.themeColors?.bodyText || "#374E3D",
  };

  return (
    <div
      // className="whiteTheme"
      style={{
        height: "3.3rem",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        gap: "0.3rem",
        alignItems: "center",
        padding: "1.5rem 2rem",
        margin: "auto",
        paddingBottom: "2rem",
        backgroundColor: "inherit",
        position: "sticky",
        top: "2.5rem",
        zIndex: 5,
        borderBottom: "0.5px solid rgb(7, 159, 43, 0.8)",
        fontSize: "0.9rem",
        // color: "#495057",
        fontWeight: "500",
        textAlign: "center",
        boxShadow: "0 3px 6px rgba(0, 0, 0, 0.1)",
        width: "95%",
      }}
    >
      <LinkContainer to="/userRegistration" style={subMenuStyle}>
        <Nav.Link>
          {" "}
          <FaUserPlus style={{ height: "1.5rem", width: "1.5rem" }} />
          <br />
          {preferredLanguage[selectedLanguage]?.userReg}
        </Nav.Link>
      </LinkContainer>

      <LinkContainer to="/subscriptions" style={subMenuStyle}>
        <Nav.Link>
          <FaMoneyBillAlt style={{ height: "1.5rem", width: "1.5rem" }} />
          <br />
          {preferredLanguage[selectedLanguage]?.subscriptions}
        </Nav.Link>
      </LinkContainer>

      <LinkContainer to="/attendanceList" style={subMenuStyle}>
        <Nav.Link>
          {" "}
          <FaClipboardList style={{ height: "1.5rem", width: "1.5rem" }} />
          <br />
          {preferredLanguage[selectedLanguage]?.attendanceList}
        </Nav.Link>
      </LinkContainer>

      <LinkContainer to="/users" style={subMenuStyle}>
        <Nav.Link>
          <FaUsers style={{ height: "1.5rem", width: "1.5rem" }} />
          <br />
          {preferredLanguage[selectedLanguage]?.activeMember}
        </Nav.Link>
      </LinkContainer>

      <LinkContainer to="/subsExpiredUsers" style={subMenuStyle}>
        <Nav.Link>
          <FaUsersSlash style={{ height: "1.5rem", width: "1.5rem" }} />
          <br />
          {preferredLanguage[selectedLanguage]?.inActiveMembers}
        </Nav.Link>
      </LinkContainer>

      <LinkContainer to="/payments" style={subMenuStyle}>
        <Nav.Link>
          <FaMoneyBillAlt style={{ height: "1.5rem", width: "1.5rem" }} />
          <br />
          {preferredLanguage[selectedLanguage]?.paymentsList}
        </Nav.Link>
      </LinkContainer>

      <LinkContainer to="/pendingPayments" style={subMenuStyle}>
        <Nav.Link>
          <FaMoneyBillAlt style={{ height: "1.5rem", width: "1.5rem" }} />
          <br />
          Pending Payments
        </Nav.Link>
      </LinkContainer>

      <LinkContainer to="/accounts" style={subMenuStyle}>
        <Nav.Link>
          <MdAccountBalance style={{ height: "1.5rem", width: "1.5rem" }} />
          <br />
          {preferredLanguage[selectedLanguage]?.accounts}
        </Nav.Link>
      </LinkContainer>

      <LinkContainer to="/packages" style={subMenuStyle}>
        <Nav.Link>
          <CgMenuBoxed style={{ height: "1.5rem", width: "1.5rem" }} />
          <br />
          Packages
        </Nav.Link>
      </LinkContainer>

      <LinkContainer to="/reminders" style={subMenuStyle}>
        {/* twinkle-text is the animation already defined in
            bootstrap.custom.css, so a pending reminder pulses this item
            without adding any new CSS. */}
        <Nav.Link className={reminderCount > 0 ? "twinkle-text" : ""}>
          <FaBell style={{ height: "1.5rem", width: "1.5rem" }} />
          <br />
          Reminders
          {reminderCount > 0 && (
            <span
              style={{
                background: "red",
                color: "white",
                borderRadius: "50%",
                padding: "0 0.35rem",
                fontSize: "0.7rem",
                marginLeft: "0.25rem",
              }}
            >
              {reminderCount}
            </span>
          )}
        </Nav.Link>
      </LinkContainer>
    </div>
  );
}

export default TopSubMenu;
